import React from 'react';
import { useMatch } from 'react-router-dom';
import { useSession } from '@/hooks/useSession';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import { PATHS } from '@/routes/paths';
import { AdminMetrics } from './AdminMetrics';
import { ExamsMetricsUser } from './exams-metrics-user';
import { ResultadosPlayfulTeacher } from './PlayfulTeacher';

export function ExamMetrics() {
  const { session } = useSession();
  const isPlayfulTeacher = usePlayfulTeacher();
  const isExamResultRoute = !!useMatch(PATHS.EXAM.EXAM_RESULT_DETAIL_ROOT);

  const sessionUser = session.user.profileNames[0];

  if (sessionUser === 'Aluno') return <ExamsMetricsUser />;
  if (isPlayfulTeacher && isExamResultRoute) return <ResultadosPlayfulTeacher />;
  return <AdminMetrics />;
}
